var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-loading',{attrs:{"is-full-page":true,"can-cancel":false},model:{value:(_vm.$store.getters.getLoading),callback:function ($$v) {_vm.$set(_vm.$store.getters, "getLoading", $$v)},expression:"$store.getters.getLoading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }